module.exports = __webpack_public_path__ + "static/confetti-34f482aff2705e9cda79db84d4ff9382.svg";